import { createAction, props } from '@ngrx/store';
import { Order } from '@shared/models/order';

export const loadCartCustomerOrders = createAction('[Cart] Load Cart Customer Orders', props<{ groupId: string }>());

export const loadCartCustomerOrdersSuccess = createAction(
  '[Cart] Load Cart Customer Orders Success',
  props<{ orders: Order[] }>(),
);

export const loadCartCustomerOrdersFailure = createAction(
  '[Cart] Load Cart Customer Orders Failure',
  props<{ error: any }>(),
);
